import React from "react";
import AnimationRevealPage from "../../../../helpers/AnimationRevealPage.js";
import tw from "twin.macro";
import Header from "../../../../Components/headers/PageHeader";
import MainFeature1 from "../../../../Components/Features/TwoColWithButton.js";
import Features from "../../../../Components/Features/ThreeColumnPages";
import {
  FaVideo,
  FaWallet,
  FaStar,
  FaRocket,
  FaMobileAlt,
  FaCheckCircle,
} from "react-icons/fa";

// Styled Components
const Subheading = tw.span`uppercase tracking-wider text-sm`;
const Heading = tw.h1`text-2xl md:text-4xl lg:text-5xl font-bold`;
const Description = tw.p`text-base md:text-lg lg:text-xl`;

export const AffordableVideoProductionInBurDubai = () => {
  return (
    <AnimationRevealPage>
      {/* Header Section */}
      <Header from="Affordable Video Production in Bur Dubai" />

      {/* Hero Section */}
      <MainFeature1
        subheading={<Subheading>Quality Meets Affordability</Subheading>}
        heading={
          <Heading>
            Affordable <span tw="text-primary-500">Video Production</span> in
            Bur Dubai
          </Heading>
        }
        description={
          <Description>
            At MilaajBrandset, we provide affordable video production services
            in **Bur Dubai**, delivering high-quality visuals and engaging
            storytelling without breaking the bank. Elevate your brand with
            cost-effective videos that shine.
          </Description>
        }
        imageSrcs={[
          "https://images.unsplash.com/photo-1626447852944-a375e7629e3b?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80",
          "https://images.unsplash.com/photo-1580537659466-0a9bfa916a54?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80",
          "https://images.unsplash.com/photo-1513258496099-48168024aec0?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80",
        ]}
        widths={["55%", "60%", "70%"]}
        heights={["45%", "60%", "35%"]}
        imageColumnStyle="height: 400px;"
        imageStyle="width: 45%; height: 60%;"
        imagePositions={[
          "left: 35%; top: 20%;",
          "right: 30%; top: 10%;",
          "left: 32%; bottom: 20%;",
        ]}
        primaryButtonText="Get Started Now"
        buttonRounded={true}
        textOnLeft={false}
      />

      {/* Key Benefits Section */}
      <Features
        subheading={<Subheading>Why Choose Us?</Subheading>}
        heading="Affordable Video Excellence in Bur Dubai"
        description="We offer budget-friendly video production with professional results."
        cards={[
          {
            icon: <FaWallet color="#ff5464" size={40} />,
            title: "Cost-Effective Solutions",
            description: "High-quality videos at affordable prices.",
          },
          {
            icon: <FaVideo color="#ff5464" size={40} />,
            title: "Professional Quality",
            description: "Stunning visuals that rival premium services.",
          },
          {
            icon: <FaRocket color="#ff5464" size={40} />,
            title: "Quick Delivery",
            description: "Fast turnaround to meet your deadlines.",
          },
          {
            icon: <FaMobileAlt color="#ff5464" size={40} />,
            title: "Multi-Platform Ready",
            description: "Videos optimized for web, mobile, and social media.",
          },
          {
            icon: <FaStar color="#ff5464" size={40} />,
            title: "Trusted by Locals",
            description: "Bur Dubai’s go-to for affordable video production.",
          },
          {
            icon: <FaCheckCircle color="#ff5464" size={40} />,
            title: "Tailored Packages",
            description: "Customized options to fit your budget.",
          },
        ]}
      />

      {/* Our Process Section */}
      <MainFeature1
        subheading={<Subheading>How We Work</Subheading>}
        heading="Our Affordable Production Process"
        description={
          <Description>
            We deliver cost-effective videos with a streamlined approach:
            <ul tw="mt-4 list-disc pl-6">
              <li>Consultation: Understand your vision and budget.</li>
              <li>Planning: Create a cost-efficient production plan.</li>
              <li>
                Filming: Capture quality visuals with optimized resources.
              </li>
              <li>Editing: Enhance with professional effects and sound.</li>
              <li>Delivery: Provide polished videos ready for use.</li>
              <li>Support: Offer affordable maintenance and updates.</li>
            </ul>
          </Description>
        }
        imageSrcs={[
          "https://images.unsplash.com/photo-1616469829581-77edf95863c9?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80",
          "https://images.unsplash.com/photo-1540655037529-dec987208707?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80",
          "https://images.unsplash.com/photo-1502086223501-7ea6ecd79368?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80",
        ]}
        widths={["60%", "55%", "70%"]}
        heights={["60%", "45%", "35%"]}
        imageColumnStyle="height: 400px;"
        imageStyle="width: 45%; height: 60%;"
        imagePositions={[
          "right: 30%; top: 10%;",
          "left: 35%; bottom: 20%;",
          "right: 32%; bottom: 10%;",
        ]}
        primaryButtonText="Learn More"
        buttonRounded={true}
        textOnLeft={true}
      />

      {/* Success Stories Section */}
      <Features
        subheading={<Subheading>Success Stories</Subheading>}
        heading="Affordable Wins in Bur Dubai"
        description="Our budget-friendly videos have made a big impact."
        cards={[
          {
            icon: <FaVideo color="#ff5464" size={40} />,
            title: "Engaging Content",
            description: "Boosted brand reach with affordable ads.",
          },
          {
            icon: <FaStar color="#ff5464" size={40} />,
            title: "Client Satisfaction",
            description: "90% approval for cost-effective solutions.",
          },
          {
            icon: <FaCheckCircle color="#ff5464" size={40} />,
            title: "Local Impact",
            description: "Empowered small businesses in Bur Dubai.",
          },
        ]}
      />

      {/* Call-to-Action Section */}
      <MainFeature1
        subheading={<Subheading>Ready for Affordable Videos?</Subheading>}
        heading="Affordable Video Production in Bur Dubai"
        description={
          <Description>
            Partner with MilaajBrandset for affordable video production services
            in Bur Dubai. Get high-quality, budget-friendly videos that elevate
            your brand—contact us today!
          </Description>
        }
        imageSrcs={[
          "https://images.unsplash.com/photo-1574717024453-354056afd83e?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80",
          "https://images.unsplash.com/photo-1518135714426-c18f5ffb6f4d?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80",
          "https://images.unsplash.com/photo-1523741543316-beb7fc7023d8?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80",
        ]}
        widths={["55%", "60%", "70%"]}
        heights={["45%", "60%", "35%"]}
        imageColumnStyle="height: 400px;"
        imageStyle="width: 45%; height: 60%;"
        imagePositions={[
          "left: 35%; top: 20%;",
          "right: 30%; top: 10%;",
          "left: 32%; bottom: 20%;",
        ]}
        primaryButtonText="Contact Us Now"
        buttonRounded={true}
        textOnLeft={false}
      />
    </AnimationRevealPage>
  );
};
